import { Button } from '@acorns/web-components'
import styled from 'styled-components'

import { style } from 'theme'

const StyledForm = styled.form`
  margin: 40px auto 80px;
`

const TextInputWrapper = styled.div`
  div,
  input {
    width: 100%;
  }
`

const AddressRow = styled.div`
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-bottom: 20px;

  /** TextInputV3 has some weird opinionated width styles we need to force override. Sigh. */
  div {
    width: 100%;
  }

  @media screen and (max-width: ${style(theme => theme.breakpoints.md)}px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }
`

const CityStateZipRow = styled.div`
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(3, minmax(0, 1fr));

  @media screen and (max-width: ${style(theme => theme.breakpoints.md)}px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }
`
const StyledButton = styled(Button)`
  margin: auto;
  width: 220px;

  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-top: 0;
    width: 100%;
  }
`

export { StyledForm, AddressRow, CityStateZipRow, TextInputWrapper, StyledButton }
